<!-- @format -->

<ng-container *ngIf="hasInvalidSelections">
  <ng-container *transloco="let t">
    <fudis-heading [level]="3">{{ t("PLAN_STRUCTURE_EDIT.INVALID_SELECTIONS_TITLE") }}</fudis-heading>
    <div class="sis-pt-sm" *ngFor="let courseUnit of invalidCourseUnits">
      <sis-plan-structure-course-unit
        [courseUnit]="courseUnit"
        [planStateObject]="planStateObject"
        [planData]="planData"
        [headingLevel]="headingLevel"
        [action]="'select-to-plan'"
        [selected]="validatablePlan.isCourseUnitInPlan(courseUnit)"
        (actionChange)="handleCourseUnitToggle(courseUnit)"
      >
      </sis-plan-structure-course-unit>
    </div>
    <div class="sis-pt-sm" *ngFor="let customCourseUnitAttainment of invalidCustomCourseUnitAttainments">
      <sis-plan-structure-custom-course-unit-attainment
        [customCourseUnitAttainment]="customCourseUnitAttainment"
        [planStateObject]="planStateObject"
        [headingLevel]="headingLevel"
        [action]="'select-to-plan'"
        [selected]="validatablePlan.isCustomCourseUnitAttainmentInPlan(customCourseUnitAttainment)"
        (actionChange)="handleCustomCourseUnitAttainmentToggle(customCourseUnitAttainment)"
      >
      </sis-plan-structure-custom-course-unit-attainment>
    </div>
    <div class="sis-pt-sm" *ngFor="let customStudyDraft of invalidCustomStudyDrafts">
      <sis-plan-structure-custom-study-draft
        [customStudyDraft]="customStudyDraft"
        [planStateObject]="planStateObject"
        [headingLevel]="headingLevel"
        [action]="'select-to-plan'"
        [selected]="isCustomStudyDraftInPlan(customStudyDraft)"
        (actionChange)="handleCustomStudyDraftToggle(customStudyDraft)"
      >
      </sis-plan-structure-custom-study-draft>
    </div>
    <div class="sis-pt-sm" *ngFor="let module of invalidModules">
      <ng-container *ngIf="module.type === 'DegreeProgramme'">
        <sis-plan-structure-degree-programme-box
          [module]="$any(module)"
          [planStateObject]="planStateObject"
          [planData]="planData"
          [headingLevel]="headingLevel"
          [action]="'select-to-plan'"
          [selected]="validatablePlan.isModuleInPlan(module.id)"
          (actionChange)="handleModuleToggle(module)"
        >
        </sis-plan-structure-degree-programme-box>
      </ng-container>
      <ng-container *ngIf="module.type === 'StudyModule'">
        <sis-plan-structure-study-module-box
          [module]="$any(module)"
          [planStateObject]="planStateObject"
          [planData]="planData"
          [headingLevel]="headingLevel"
          [action]="'select-to-plan'"
          [selected]="validatablePlan.isModuleInPlan(module.id)"
          (actionChange)="handleModuleToggle(module)"
        >
        </sis-plan-structure-study-module-box>
      </ng-container>
    </div>
    <div class="sis-pt-sm" *ngFor="let customModuleAttainment of invalidCustomModuleAttainments">
      <sis-plan-structure-custom-module-attainment-box
        [customModuleAttainment]="customModuleAttainment"
        [planStateObject]="planStateObject"
        [headingLevel]="headingLevel"
        [action]="'select-to-plan'"
        [selected]="validatablePlan.isModuleAttainmentInPlan(customModuleAttainment.id)"
        (actionChange)="handleCustomModuleAttainmentToggle(customModuleAttainment)"
      >
      </sis-plan-structure-custom-module-attainment-box>
    </div>
  </ng-container>
</ng-container>
